import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import {
  LocalMall,
  ManageHistory,
  Summarize,
  Factory,
  PrecisionManufacturing,
  LocalShipping
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { itemsServerAccessMenu } from './ItemsServerAccess';
import { ButtonWithRedirect } from '../../../components/commons/ButtonWithRedirect/ButtonWithRedirect';
import { colors } from '../../../constants/colors';
import { selectCurrentUser } from '../../../store/slices/login/login';

export const ServerAccessMenuComponent = () => {
  const contextUser = useSelector(selectCurrentUser) as any;
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={10} md={8}>
          <Box
            sx={{
              flexGrow: 1,
              border: `1px solid ${colors.lightGray}`,
              overflowY: 'auto',
              maxHeight: '80vh'
            }}
            marginTop={3}
          >
            <Grid container spacing={2} marginTop={2}>
              {itemsServerAccessMenu.map((element) =>
                contextUser.roleInfo.permissionsByModule?.find(
                  (module: any) => module.systemModuleName === element.key
                ) ? (
                  <Grid
                    item
                    xs={6}
                    md={4}
                    key={element.text}
                    textAlign="center"
                  >
                    <ButtonWithRedirect
                      icon={element.icon}
                      text={element.text}
                      url={element.url}
                    />
                  </Grid>
                ) : null
              )}
              <Grid item xs={6} md={4} key="store" textAlign="center">
                <ButtonWithRedirect
                  icon={<LocalMall />}
                  text="Effects Store"
                  url="/effects/store"
                />
              </Grid>
              <Grid item xs={6} md={4} key="reports" textAlign="center">
                <ButtonWithRedirect
                  icon={<Summarize />}
                  text="Reports"
                  url="/reports"
                />
              </Grid>
              <Grid item xs={6} md={4} key="reports" textAlign="center">
                <ButtonWithRedirect
                  icon={<Summarize />}
                  text="Application Logs"
                  url="/server-access/applications-logs"
                />
              </Grid>
              <Grid item xs={6} md={4} key="store" textAlign="center">
                <ButtonWithRedirect
                  icon={<Factory />}
                  text="Manufacturing Part Number"
                  url="/Manufacturing/PartNumber"
                />
              </Grid>
              <Grid item xs={6} md={4} key="reports" textAlign="center">
                <ButtonWithRedirect
                  icon={<PrecisionManufacturing />}
                  text="Manufacturing Serial Numbers"
                  url="/Manufacturing/SerialNumber"
                />
              </Grid>
              <Grid item xs={6} md={4} key="reports" textAlign="center">
                <ButtonWithRedirect
                  icon={<LocalShipping />}
                  text="Manufacturing Shipping Order"
                  url="/Manufacturing/shippingOrder"
                />
              </Grid>
              <Grid item xs={6} md={4} key="reports" textAlign="center">
                <ButtonWithRedirect
                  icon={<ManageHistory />}
                  text="Code Versions"
                  url="/codeVersions"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
